export const AUTH_TOKEN_KEY = 'token'

export const TYPE_ACCOUNT_KEY = 'typeAccount'

export const USER_NAME_KEY = 'username'

export const DATA_DISTRIBUTOR_KEY = 'dataDistributor'

export const CUSTOMER_INFORMATION_KEY = 'customerInformation'